<div *ngIf="isShowGuide">
  <p class="m-b-10">
    {{ note | translate }}
  </p>
  <h5 class="f-w-600">
    {{ "location.promote.specification" | translate }}
  </h5>
  <div class="m-b-10 m-l-30 color-darkGray">
    <div class="m-l-5">
      <ul>
        <li class="font-a">
          <b>{{ "newCampaign.step2.specification.line1.title" | translate }}</b
          >{{ "newCampaign.step2.specification.line1.description" | translate }}
        </li>
        <li class="font-a">
          <b>{{ "newCampaign.step2.specification.line2.title" | translate }}</b
          >{{ "newCampaign.step2.specification.line2.description" | translate }}
        </li>
        <li class="font-a">
          <b>{{ "newCampaign.step2.specification.line3.title" | translate }}</b
          >{{ "newCampaign.step2.specification.line3.description" | translate }}
        </li>
        <li class="font-a">
          <b>{{ "newCampaign.step2.specification.line4.title" | translate }}</b
          >{{ "newCampaign.step2.specification.line4.description" | translate }}
        </li>
        <li class="font-a">
          <b>{{ "newCampaign.step2.specification.line5.title" | translate }}</b
          >{{ "newCampaign.step2.specification.line5.description" | translate }}
        </li>
      </ul>
    </div>
  </div>

  <label class="col-form-label label p-t-0">
    {{ "newCampaign.step2.specification.downloadGuide.part1" | translate }}
    <a
      type="button"
      style="color: #ff69b4"
      class="font-a"
      [href]="videoGuideLink"
      target="_blank"
      >{{
        "newCampaign.step2.specification.downloadGuide.part2" | translate
      }}</a
    >
  </label>
</div>

<div [ngClass]="{ 'p-r-30': isShowGuide }">
  <div class="m-b-10" *ngIf="showProgress">
    <ngb-progressbar [value]="uploadProgress"
      >{{ uploadProgress }}%</ngb-progressbar
    >
  </div>
  <ngx-dropzone
    [multiple]="false"
    (change)="onSelect($event.addedFiles)"
    accept="video/*"
  >
    <ngx-dropzone-label>
      <div>
        <div class="dz-message needsclick">
          <i class="icon-cloud-up"></i>
          <p style="color: black">
            {{ "dropzoneFile.title" | translate }}
          </p>
          <p class="dz-message needsclick" style="color: black">
            {{ "dropzoneFile.rulePart1" | translate }}
            <strong [ngClass]="{ 'txt-danger': showError }"
              >{{ "dropzoneFile.rulePart2" | translate }} 5MB</strong
            >
          </p>
        </div>
      </div>
    </ngx-dropzone-label>
    <ngx-dropzone-preview
      *ngFor="let f of files"
      [removable]="true"
      [file]="f"
      (removed)="onRemove(f)"
    >
      <ngx-dropzone-label style="align-self: flex-end; margin: 0">
        <div class="ligne-top"></div>
        <div class="new-dropdown-label">
          {{ f.name.split(".")[0] | castFileName }} .{{ f.type.split("/")[1] }}
        </div>
      </ngx-dropzone-label>
    </ngx-dropzone-preview>
  </ngx-dropzone>
</div>
